import type { Availability } from '@cocoonspace/sdk-js/types/availability'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { useLingui } from '@lingui/react/macro'

import { InfoPopover } from '~/components/atoms/info-popover'
import { Price } from '~/components/price'
import { usePromotionsTrads } from '~/lib/get-promotions-trads'

export const FooterPriceCreate = ({
	availability,
}: {
	availability: Availability
}) => {
	const { t } = useLingui()
	const promotionsTrads = usePromotionsTrads()

	return (
		<div>
			<div className='flex flex-row items-center gap-1 text-sm'>
				{t`soit`}

				<Price
					className='font-normal'
					crossed={availability?.price_hour_discounted !== undefined}
					price={availability?.price_hour}
				/>

				{availability?.price_hour_discounted !== undefined && (
					<Price
						className='text-primary'
						price={availability?.price_hour_discounted}
					/>
				)}

				<div>x</div>

				{dateTimeUtils
					.duration(availability?.billed_minutes || 0, 'minutes')
					.format('H[h]mm')}

				{availability?.price_hour_discounted !== undefined &&
					availability?.rebate_codes?.[0] &&
					promotionsTrads[availability?.rebate_codes?.[0]] && (
						<InfoPopover>
							{promotionsTrads[availability?.rebate_codes?.[0]]()}
						</InfoPopover>
					)}
			</div>

			{availability?.price > 0 ? (
				<div>
					<Price
						data-testid='due-price'
						price={availability?.price}
						taxClassName='mb-[1px] text-xxs font-normal'
						taxType='ht'
					/>
				</div>
			) : (
				<div
					className='font-bold'
					data-testid='free-price'
				>
					{t`Gratuit`}
				</div>
			)}
		</div>
	)
}
